/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "DeviceEventType": {
                "values": {
                  "DEVICE_EVENT_TYPE_INVALID_TYPE": 0,
                  "BLACK_MARK_ERROR_EVENT_TYPE": 1,
                  "BUSY_EVENT_TYPE": 2,
                  "CALIBRATION_ERROR_EVENT_TYPE": 3,
                  "CALIBRATION_WARNING_EVENT_TYPE": 4,
                  "CHARGING_PAUSED_EVENT_TYPE": 5,
                  "CHARGING_SLOWLY_EVENT_TYPE": 6,
                  "CHECKING_FOR_UPDATES_EVENT_TYPE": 7,
                  "CONNECTING_EVENT_TYPE": 8,
                  "COVER_OPEN_EVENT_TYPE": 9,
                  "CUTTER_ERROR_EVENT_TYPE": 10,
                  "DISCONNECTED_EVENT_TYPE": 11,
                  "ESTABLISHING_SECURE_SESSION_EVENT_TYPE": 12,
                  "FAILED_PRINT_JOB_EVENT_TYPE": 13,
                  "FAILED_TO_CONNECT_EVENT_TYPE": 14,
                  "FATAL_ERROR_EVENT_TYPE": 15,
                  "FIRMWARE_ERROR_EVENT_TYPE": 16,
                  "FIRMWARE_UPDATE_COMPLETED_EVENT_TYPE": 17,
                  "FIRMWARE_UPDATE_FAILED_EVENT_TYPE": 18,
                  "FORCE_OFFINE_PAYMENTS_DISABLED_EVENT_TYPE": 19,
                  "FORCE_OFFINE_PAYMENTS_UNAVAILABLE_EVENT_TYPE": 20,
                  "FORCE_OFFLINE_PAYMENTS_ENABLED_EVENT_TYPE": 21,
                  "GENERIC_ERROR_EVENT_TYPE": 22,
                  "INCOMPATIBLE_EVENT_TYPE": 23,
                  "INCORRECT_PAPER_TYPE_EVENT_TYPE": 24,
                  "INSUFFICIENT_POWER_EVENT_TYPE": 25,
                  "INTERRUPTED_EVENT_TYPE": 26,
                  "LOCAL_NETWORK_PERMISSION_DENIED_EVENT_TYPE": 27,
                  "LOW_BATTERY_EVENT_TYPE": 28,
                  "LOW_PAPER_EVENT_TYPE": 29,
                  "LOW_SIGNAL_STRENGTH_EVENT_TYPE": 30,
                  "MECHANICAL_ERROR_EVENT_TYPE": 31,
                  "MEMORY_ERROR_EVENT_TYPE": 32,
                  "NOT_CONFIGURED_EVENT_TYPE": 33,
                  "NOT_READY_EVENT_TYPE": 34,
                  "OFFLINE_EVENT_TYPE": 35,
                  "OFFLINE_PAYMENT_ISSUES_EVENT_TYPE": 36,
                  "OFFLINE_PAYMENTS_AVAILABLE_FOR_SOME_READERS_EVENT_TYPE": 37,
                  "OFFLINE_PAYMENTS_ENABLED_EVENT_TYPE": 38,
                  "OFFLINE_PAYMENTS_ERROR_EVENT_TYPE": 39,
                  "OFFLINE_PAYMENTS_NOT_SUPPORTED_EVENT_TYPE": 40,
                  "OFFLINE_PAYMENTS_UNAVAILABLE_EVENT_TYPE": 41,
                  "OFFLINE_SWIPE_ONLY_EVENT_TYPE": 42,
                  "OPERATION_UNSUPPORTED_EVENT_TYPE": 43,
                  "OUT_OF_BATTERY_EVENT_TYPE": 44,
                  "OUT_OF_PAPER_EVENT_TYPE": 45,
                  "OVER_CAPACITY_EVENT_TYPE": 46,
                  "OVERHEATED_EVENT_TYPE": 47,
                  "PAPER_JAMMED_EVENT_TYPE": 48,
                  "PAPER_PRESENT_EVENT_TYPE": 49,
                  "PAUSED_EVENT_TYPE": 50,
                  "PRINT_HEAD_DIRTY_EVENT_TYPE": 51,
                  "PRINT_HEAD_EOL_EVENT_TYPE": 52,
                  "PRINT_HEAD_ERROR_EVENT_TYPE": 53,
                  "READY_EVENT_TYPE": 54,
                  "REBOOTING_EVENT_TYPE": 55,
                  "RIBBON_OUT_EVENT_TYPE": 56,
                  "SECURE_SESSION_DENIAL_EVENT_TYPE": 57,
                  "SECURE_SESSION_SERVER_ERROR_EVENT_TYPE": 58,
                  "SECURITY_MODE_EVENT_TYPE": 59,
                  "SIGNED_IN_EMPLOYEE_EVENT_TYPE": 60,
                  "SYSTEM_ERROR_EVENT_TYPE": 61,
                  "TAMPERED_EVENT_TYPE": 62,
                  "TEST_MERCHANT_EVENT_TYPE": 63,
                  "THERMOMETER_DAMAGED_EVENT_TYPE": 64,
                  "TIMED_OUT_EVENT_TYPE": 65,
                  "TOO_COLD_EVENT_TYPE": 66,
                  "TURN_ON_BLUETOOTH_EVENT_TYPE": 67,
                  "UNABLE_TO_CHARGE_EVENT_TYPE": 68,
                  "UNDER_CAPACITY_EVENT_TYPE": 69,
                  "UNEXPECTED_RESPONSE_EVENT_TYPE": 70,
                  "UNKNOWN_DEVICE_EVENT_TYPE": 71,
                  "UNREACHABLE_EVENT_TYPE": 72,
                  "UNRECOVERABLE_ERROR_EVENT_TYPE": 73,
                  "UPDATE_NEEDED_EVENT_TYPE": 74,
                  "UPDATING_EVENT_TYPE": 75,
                  "VERY_LOW_BATTERY_EVENT_TYPE": 76,
                  "VOLTAGE_ERROR_EVENT_TYPE": 77,
                  "NETWORK_MISTMATCH_ERROR_EVENT_TYPE": 78,
                  "NOT_CONNECTED_TO_NETWORK_ERROR_EVENT_TYPE": 79,
                  "USB_PRINTER_UNPLUGGED_ERROR_EVENT_TYPE": 80,
                  "DEVICE_SUPPORTED_OFFER_EVENT_TYPE": 81,
                  "DEVICE_SUPPORT_ENDING_OFFER_EVENT_TYPE": 82,
                  "DEVICE_SUPPORTED_NO_OFFER_EVENT_TYPE": 83,
                  "DEVICE_SUPPORT_ENDING_NO_OFFER_EVENT_TYPE": 84,
                  "DEVICE_UNSUPPORTED_EVENT_TYPE": 85,
                  "SOFTWARE_FREEZE_WARN_OFFER_EVENT_TYPE": 86,
                  "SOFTWARE_FREEZE_WARN_EVENT_TYPE": 87,
                  "SOFTWARE_FROZEN_OFFER_EVENT_TYPE": 88,
                  "SOFTWARE_FROZEN_EVENT_TYPE": 89,
                  "PAYMENT_STOP_WARN_OFFER_EVENT_TYPE": 90,
                  "PAYMENT_STOP_WARN_EVENT_TYPE": 91,
                  "PAYMENT_STOP_OFFER_EVENT_TYPE": 92,
                  "PAYMENT_STOP_EVENT_TYPE": 93,
                  "CHARGING_PORT_CONTAMINATED_EVENT_TYPE": 94
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceEventType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceEventType @ squareup/devices/external/event_type.proto at 11:1
 */
export const DeviceEventType = $root.lookupEnum('squareup.connect.v2.DeviceEventType').values;